import { Box } from '@aicon-dev/caas-ui';
import styled from 'styled-components';

import { useReportDetailContext } from '../context/ReportDetailProvider';

export const ReportDetailTimelapse = () => {
  const { data } = useReportDetailContext();
  return (
    <Box display="grid" gap="12" pt="8">
      {data?.timelapses?.map((item, key) => (
        <div key={item.url}>
          <TimelapseBlock key={key}>
            <Video controls src={item.url} poster={item?.thumbnailUrl} preload="none" />
          </TimelapseBlock>
        </div>
      ))}
    </Box>
  );
};

const TimelapseBlock = styled.div`
  position: relative;
  height: 0;
  padding-bottom: 56.25%;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;
